import { SupportedNetworkId } from '@core/shared/enums'

export const allowedFintivXTokens: Record<SupportedNetworkId, string[]> = {
  [SupportedNetworkId.Ethereum]: [],
  [SupportedNetworkId.Base]: [],
  [SupportedNetworkId.Polygon]: [],
  [SupportedNetworkId.ArbitrumSepolia]: [],
}

export const allowedFintivTokens: Record<SupportedNetworkId, string[]> = {
  [SupportedNetworkId.Ethereum]: [],
  [SupportedNetworkId.Base]: [],
  [SupportedNetworkId.Polygon]: [],
  [SupportedNetworkId.ArbitrumSepolia]: [],
}

export const fintivTokens: Record<SupportedNetworkId, string[]> = {
  [SupportedNetworkId.Ethereum]: [],
  [SupportedNetworkId.Base]: [],
  [SupportedNetworkId.Polygon]: [],
  [SupportedNetworkId.ArbitrumSepolia]: [],
}

export const fintivXTokens: Record<SupportedNetworkId, string[]> = {
  [SupportedNetworkId.Ethereum]: [],
  [SupportedNetworkId.Base]: [],
  [SupportedNetworkId.Polygon]: [],
  [SupportedNetworkId.ArbitrumSepolia]: [],
}
